import Image from 'next/image';
import { Container, Row, Col } from 'react-bootstrap';
import { Courses } from '../../../types/schema';
import BreadcrumbComponent from '../../ui/Breadcrumb';
import CourseTabBox, { Curriculum } from '../../ui/CourseTabBox';
import { InstructorCardProps } from '../../ui/InstructorCard';
import { Certification, Styles, Subscription } from './styles';
import CourseDetails from '../../ui/CourseDetails';
import PopularCourse from '../../ui/PopularCourse';
import Link from 'next/link';
import { imageConstraints } from '../../../utils/constraints';
import { trackPixelEvent } from '../../../utils/facebook-pixel';

export type CoursePageTemplateProps = {
  course: Courses;
  popularCourses: Courses[];
  url?: string;
};

const CoursePageTemplate: React.FC<CoursePageTemplateProps> = ({ course, popularCourses, url }) => {
  const {
    title,
    description,
    shortDescription,
    authors,
    curriculum,
    image,
    startDate,
    endDate,
    category,
    price,
    skillLevel,
    subscriptionType,
    preSubscription,
    slug,
    remote,
    period,
    maxStudents = 0,
    confirmedStudents = 0,
    placeName,
    placeAddress,
    googleMapsUrl,
  } = course;
  function isFull() {
    return !!maxStudents && confirmedStudents! >= maxStudents;
  }

  function isStarted() {
    if (!startDate || !endDate) return false;

    return new Date(startDate) <= new Date();
  }

  return (
    <div className="main-wrapper course-details-page">
      {/* Breadcrumb */}
      <BreadcrumbComponent title={title} image={imageConstraints['Course-Hero']} />

      <Styles>
        {/* Course Details */}
        <section className="course-details-area">
          <Container>
            <Row>
              <Col lg="9" md="8" sm="12">
                <div className="course-details-top">
                  <Subscription>
                    {!isFull() && !isStarted() && (
                      <section>
                        <h2>{title}</h2>
                        <span>{shortDescription}</span>
                      </section>
                    )}

                    <section>
                      {isFull() && !isStarted() && (
                        <h4 className="m-auto">As vagas para este treinamento já se esgotaram</h4>
                      )}
                      {isStarted() && <h4 className="m-auto">Treinamento em andamento</h4>}

                      {!isFull() && !isStarted() && !preSubscription && (
                        <span>Inscreva-se agora mesmo e garanta sua vaga neste treinamento</span>
                      )}
                      {!isFull() && !isStarted() && preSubscription && (
                        <span>
                          Faça agora a pré-inscrição indicando seu interesse pelo treinamento, assim
                          você será avisado primeiro quando as inscrições forem abertas.
                        </span>
                      )}

                      {!isFull() && !isStarted() && (
                        <Link
                          href={{
                            pathname: `/cursos/[slug]/${
                              preSubscription ? 'pre-inscricao' : 'inscricao'
                            }`,
                            query: { slug: slug },
                          }}
                        >
                          <button
                            type="button"
                            className="enroll-btn mx-auto"
                            onClick={() => {
                              if (price && price > 0) {
                                trackPixelEvent('AddToCart');
                              }
                            }}
                          >
                            {preSubscription ? 'Pré-inscrever' : 'Inscreva-se'}
                          </button>
                        </Link>
                      )}
                    </section>
                  </Subscription>
                  {image && (
                    <div className="course-details-banner">
                      <Image
                        key={image.url}
                        priority
                        quality={50}
                        fill
                        placeholder="blur"
                        blurDataURL="/images/academy_logo.png"
                        src={image.url}
                        alt="Imagem de banner"
                        style={{ objectFit: 'cover' }}
                      />
                    </div>
                  )}
                  <CourseTabBox
                    curriculum={curriculum as Curriculum[]}
                    instructors={authors as InstructorCardProps[]}
                    description={description as string}
                    url={url}
                    title={title}
                  />
                </div>
              </Col>
              <Col lg="3" md="4" sm="12">
                <Row>
                  <Col md="12">
                    <Certification>
                      <h5 className="title">Certificado</h5>
                      <div>
                        <Image fill src="/images/certificado.jpg" quality={30} alt="certificado" />
                      </div>

                      <span>
                        Emissão de certificado {subscriptionType === 'free' ? 'online' : 'impresso'}{' '}
                        para os alunos que concluírem o treinamento com sucesso.
                      </span>
                    </Certification>
                  </Col>
                  <Col md="12">
                    <CourseDetails
                      {...{
                        // startDate: format(parseISO(startDate), 'MMM dd, yyyy'),
                        // endDate: format(parseISO(endDate), 'MMM dd, yyyy'),
                        placeName: placeName || '',
                        placeAddress: placeAddress || '',
                        googleMapsUrl: googleMapsUrl || '',
                        price: price!,
                        category: category as string,
                        subscriptionType: subscriptionType as string,
                        preSubscription: !!preSubscription,
                        skillLevel: skillLevel as string,
                        slug,
                        showButton: !isFull() && !isStarted(),
                        remote: !!remote,
                        period: period as string,
                        maxStudents: maxStudents!,
                        confirmedStudents: confirmedStudents!,
                      }}
                    />
                  </Col>
                  <Col md="12">
                    <PopularCourse courses={popularCourses} />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section>
      </Styles>
    </div>
  );
};

export default CoursePageTemplate;
